import Alert from '~/components/Alert';
import Submit from '~/components/button/Submit';
import CustomerInfoFields from '~/components/CustomerInfoFields';
import Form from '~/components/Form';
import Checkbox from '~/components/form-controls/Checkbox';
import Page from '~/components/layout/page/Page';
import Link from '~/components/Link';
import LoadingBoundary from '~/components/LoadingBoundary';
import { useIsLoading } from '~/utils/routing';
import { isDefectiveFormKey, useActionResult, useLoaderData } from './withdraw';

const loadingMessages = [
  'Submitting',
  'Getting your shipping label',
  'Working on it',
  'Almost done',
];

function Content() {
  const { address, email } = useLoaderData();
  const actionResult = useActionResult();
  const isLoading = useIsLoading();

  return (
    <Form name="withdrawForm">
      <Page.Section title="Verify your information">
        <CustomerInfoFields
          info={{
            email,
            firstName: address?.firstName,
            lastName: address?.lastName,
            address,
          }}
        />
      </Page.Section>
      <Page.Section title="Condition of your items">
        <Checkbox
          // defaultChecked={false}
          // value={undefined}
          id={isDefectiveFormKey}
          name={isDefectiveFormKey}
          label="An item was damaged or defective"
          description="Check this if one or more items arrived damaged, defective, or not as described."
        />
      </Page.Section>

      <Alert title="Withdrawing cancels your entire order" variant="info">
        Continuing exercises your statutory right of withdrawal under EU law and
        cancels the contract for the <strong>entire order</strong>. All items
        must be returned within <strong>14 days</strong> of submitting this
        withdrawal. Once we receive the items (or proof that you have returned
        them), we will refund the full order amount. If you only want to return
        some items, please{' '}
        <Link to="../return" className="underline">
          start a return
        </Link>{' '}
        instead.
      </Alert>

      {actionResult?.ok === false && (
        <Alert variant="error" title={actionResult.message} />
      )}

      <Submit loading={isLoading}>Withdraw From Contract</Submit>
    </Form>
  );
}

export default function OrderWithdrawPage() {
  const isLoading = useIsLoading();

  return (
    <Page.Root title="Withdraw Order" hideHeader>
      <LoadingBoundary isLoading={isLoading} loadingMessages={loadingMessages}>
        <Content />
      </LoadingBoundary>
    </Page.Root>
  );
}
